import { render, staticRenderFns } from "./VideoShowcase.vue?vue&type=template&id=0b7e8a82&scoped=true"
import script from "./VideoShowcase.vue?vue&type=script&lang=js"
export * from "./VideoShowcase.vue?vue&type=script&lang=js"
import style0 from "./VideoShowcase.vue?vue&type=style&index=0&id=0b7e8a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7e8a82",
  null
  
)

export default component.exports